const dateTimeStr = new Date()?.toISOString();

export const baseBCGet = ({ buildingId = '', }) => {
    return {
        buildingId: buildingId,
        created: dateTimeStr,
    };
}